/**
 * Sernelle — size guide: modale + bascule in / cm (mémorisée).
 */
(() => {
  const KEY = 'sa-unit';

  function savedUnit() {
    try { return localStorage.getItem(KEY) || 'in'; } catch (e) { return 'in'; }
  }

  function applyUnit(root, unit) {
    root.dataset.unit = unit;
    root.querySelectorAll('[data-sa-unit]').forEach((b) => b.classList.toggle('is-active', b.dataset.saUnit === unit));
  }

  function init() {
    const unit = savedUnit();
    document.querySelectorAll('[data-sa-sg]').forEach((root) => {
      if (root.dataset.unit !== unit) applyUnit(root, unit);
    });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-sa-sg-open]');
    if (opener) {
      event.preventDefault();
      const dialog = document.getElementById(opener.dataset.saSgOpen);
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
        document.body.classList.add('sa-sg-open');
      }
      return;
    }

    const closer = event.target.closest('[data-sa-sg-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    const unitButton = event.target.closest('[data-sa-unit]');
    if (unitButton) {
      const unit = unitButton.dataset.saUnit;
      try { localStorage.setItem(KEY, unit); } catch (e) { /* private mode */ }
      document.querySelectorAll('[data-sa-sg]').forEach((root) => applyUnit(root, unit));
      return;
    }

    // Clic sur le fond (backdrop) : la cible est le <dialog> lui-même.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('sa-sg__dialog')) {
      event.target.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('sa-sg__dialog')) {
      document.body.classList.remove('sa-sg-open');
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
